import {
  configureProductDucks,
  CARD_PRODUCT,
} from '@americanexpress/product-ducks';
import { MODULE_NAME } from './constants';

const productTypes = [
  CARD_PRODUCT,
];

export const configureProducts = () => {
  configureProductDucks({
    getToState: (state) => state.getIn(['modules', MODULE_NAME, 'products']),
    defaultTypes: [CARD_PRODUCT],
    filterTypes: productTypes,
    orderTypes: productTypes,
  });
};
